import useApiServices from './useApiServices';
import { globalAdminUrl } from './globalApi';
//
/**
 * @module AdminServiceService
 * @returns  it return All DataSource Apis
 */

const RecievableService = {
  RecievableGridList: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/receivable/v1/grid/list`, credential, token),
  RecievableViewRecord: (credential, token) =>
    useApiServices().postApiResponse(
      `${globalAdminUrl}/receivable/v1/view/record`,
      credential,
      token
    ),
  RecievableSaveRecord: (credential, token) =>
    useApiServices().postApi(`${globalAdminUrl}/receivable/v1/save/record`, credential, token),
  DownloadReceivableReports: (token) =>
    useApiServices().getApiBlob(
      `${globalAdminUrl}/receivable/v1/download-receivable-reports`,
      token
    )
};

export default RecievableService;
